import React from 'react';
import { StyledSvg, iconGenerator } from '../Icon';
const PauseIcon = ({ size, deg, color, }) => (React.createElement(StyledSvg, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", size: size, deg: deg, color: color },
    React.createElement("path", { d: "M7.5 4a1 1 0 011 1v10a1 1 0 01-1 1h-1a1 1 0 01-1-1V5a1 1 0 011-1h1zm6 0a1 1 0 011 1v10a1 1 0 01-1 1h-1a1 1 0 01-1-1V5a1 1 0 011-1h1z" })));
export const Pause = iconGenerator(PauseIcon);
//# sourceMappingURL=Pause.js.map